import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=c3e230a8&scoped=true"
import script from "./BookNow.vue?vue&type=script&lang=js"
export * from "./BookNow.vue?vue&type=script&lang=js"
import style0 from "./BookNow.vue?vue&type=style&index=0&id=c3e230a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e230a8",
  null
  
)

export default component.exports